import Image from 'next/image';

import { Badge } from '@flipster/react/design-system';
import ArrowTrendingDownIcon from '@flipster/react/icon/generated/ArrowTrendingDownIcon';
import ArrowTrendingUpIcon from '@flipster/react/icon/generated/ArrowTrendingUpIcon';
import { WhalePosition } from '@flipster/socket/r230522/whale-position';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import { BadgeVariantProps } from '@flipster/styled-system/recipes';
import { V2OrderSideType, V2SpotOrderSideType } from '@flipster/utils/types/base';

import { WhaleGraphicMeta } from './whale-position-card';

interface WhaleHeaderProps {
  whaleGraphicMeta: WhaleGraphicMeta;
  whalePosition: WhalePosition;
}

interface OrderSideProps {
  orderSide: V2OrderSideType | V2SpotOrderSideType;
  hideText?: boolean;
  hideIcon?: boolean;
}

//features/misc/badge의 코드. packages/tvchart에서는 참조할수 없기에 우선 복붙
const OrderSideBadge = ({ orderSide, hideText, hideIcon }: OrderSideProps) => {
  if (!orderSide) return null;

  const meta = {
    Long: {
      color: 'buy',
      trailingIcon: <ArrowTrendingUpIcon />,
    },
    Buy: {
      color: 'buy',
      trailingIcon: undefined,
    },
    Short: {
      color: 'sell',
      trailingIcon: <ArrowTrendingDownIcon />,
    },
    Sell: {
      color: 'sell',
      trailingIcon: undefined,
    },
  } satisfies Record<
    V2OrderSideType | V2SpotOrderSideType,
    { color: BadgeVariantProps['color']; trailingIcon?: React.ReactNode }
  >;

  return (
    <Badge color={meta[orderSide].color} trailingIcon={!hideIcon && meta[orderSide]?.trailingIcon}>
      {!hideText && orderSide}
    </Badge>
  );
};

export const WhaleHeader = ({ whaleGraphicMeta, whalePosition }: WhaleHeaderProps) => (
  <div
    className={hstack({
      pos: 'relative',
      w: 'fit-content',
      h: 28,
      p: 4,
      gap: 4,
      bgColor: 'background.default.level-2',
      rounded: 16,
    })}
  >
    <Image
      src={whaleGraphicMeta.image}
      alt={whaleGraphicMeta.text}
      width={whaleGraphicMeta.width}
      height={whaleGraphicMeta.height}
      className={css({
        objectFit: 'contain',
        userSelect: 'none',
        pointerEvents: 'none',
      })}
      style={{
        marginLeft: whaleGraphicMeta.leftMargin,
        marginRight: whaleGraphicMeta.rightMargin,
      }}
    />
    <div
      className={css({
        gridArea: 'whale-type',
        color: 'content.default.level-5',
        textStyle: 'Text/XS/Strong',
        w: 'fit-content',
        whiteSpace: 'pre',
      })}
    >
      {whaleGraphicMeta.text}
    </div>
    {whalePosition?.side && <OrderSideBadge orderSide={whalePosition.side} hideIcon />}
  </div>
);
